// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"407":"e185c0a6","780":"76ad2815"}[chunkId] + ".chunk.css";
};